import React from "react"
import styles from "./checkbox.module.scss"
import MaterialIcon from "../material-icon/material-icon-view"

export interface CheckboxProperties {
  checked?: boolean
  disabled?: boolean
  name: string
  label: React.ReactNode
  personalData?: boolean
  onChange?: () => void
  highContrast?: boolean
}

export const Checkbox: React.FC<CheckboxProperties> = ({checked = false, disabled = false, name,
  label, personalData = false, onChange, highContrast = false}) => {

  function toggleCheckbox() {
    if (onChange) onChange()
  }

  return <label>
    <input checked={checked} disabled={disabled} className={styles.Input} type="checkbox" name={name} onChange={toggleCheckbox}/>
    <div className={highContrast ? styles.LabelFieldHighContrast : styles.LabelField} data-hj-suppress={personalData}>
      <MaterialIcon name="check_box"/>
      <span className={styles.CheckBoxText}>{label}</span>
    </div>
  </label>
}
